// extracted by mini-css-extract-plugin
export default {"wrapper":"Beacon_wrapper","beacon":"Beacon_beacon"};